import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Clipboard } from '@angular/cdk/clipboard';

// Angular material
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

// Generic dialogs
import { InformationPopupComponent } from '../../components/popups/information-popup/information-popup.component';
import { DecisionPopupComponent } from '../../components/popups/decision-popup/decision-popup.component';
import { CorporateLicensePopupComponent } from '../../components/popups/corporate-license-popup/corporate-license-popup.component';

// Custom services
import { LanguageService } from '../language/language.service';


@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private _http: HttpClient,
    private clipboard: Clipboard,
    private _snackBar: MatSnackBar,
    public dialog:MatDialog,
    public languageService:LanguageService,
  ) { }

  // ---------- Dictionary deep copy ---------- //

  deepCopyDict(inputArray:any){
    return structuredClone(inputArray)   //-> Right way, still beta. Will be out soon
    //return JSON.parse(JSON.stringify(inputArray));
  }

  // ---------- Snack bar ---------- //
  displaySnackBar(message:string){
    this._snackBar.open(message, '', {
      duration: 3000,
      horizontalPosition:'center',
      verticalPosition:'bottom',
      panelClass: 'simple-snackbar'
    });
  }

  // ----- Copy to clipboard ----- //
  copyToClipboard(value:string){
    // Copy value to clipboard
    const success = this.clipboard.copy(value);
    if(success){
      this.displaySnackBar(this.languageService.Strings.messages.info_copiedToClipboard)
    }
  }

  // ----- HTTPs Requests ----- //
  async executeHttpPostMethod(urlString: string, bodyDictionary: any, idToken: string) {
    let httpOptions = {
        headers: new HttpHeaders({
            'Authorization': `Bearer ${idToken}`,
        }),
    };
    try {
        // Usar lastValueFrom para convertir el Observable a Promesa y esperar el resultado
        let result = await lastValueFrom(
            this._http.post<any>(urlString, bodyDictionary, httpOptions)
        );
        return { 'success': true, 'result': result }; 
    } catch (error) {
        // Al usar lastValueFrom, los errores del Observable se propagan aquí
        console.error(error);
        return { 'success': false, 'error': error };
    }
  }

  




  // ----- Generic Dialogs ----- //

  displaySuccessPopup(popupText:string){
    this.dialog.open(
      InformationPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:this.languageService.Strings.messages.popupTitle_genericSuccess, popupText:popupText},
        width: '500px',  
      } 
    )
  }

  displayErrorPopup(popupText:string){
    this.dialog.open(
      InformationPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:this.languageService.Strings.errors.popupTitle_generic, popupText:popupText},
        width: '500px',  
      } 
    )
  }

  displayInformationPopup(popupTitle:string, popupText:string){
    this.dialog.open(
      InformationPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:popupTitle, popupText:popupText},
        width: '500px',  
      } 
    )
  }

  displayDecisionPopup(popupTitle:string, popupText:string, targetCallbackMethod: (data: any) => void){
    this.dialog.open(
      DecisionPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:popupTitle, popupText:popupText},
        width: '500px',  
      } 
    ).afterClosed().subscribe(result => targetCallbackMethod(result))
  }

  displayCorporateLicensePopup(region:string, domain:string, data:any){
    this.dialog.open(
      CorporateLicensePopupComponent, 
      {
        disableClose: true,
        data: {region:region, domain:domain, data:data},
        width: '85%', 
        height: '85%' 
      } 
    )
  }


}
